module.exports = __webpack_public_path__ + "static/media/icon-boletins.18eb4c5c.svg";